module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-en.f51e28ca.svg";